var map = {
	"./404.svg": 8418,
	"./acc-pay-illustration-banner.svg": 5994,
	"./acc-pay-illustration-modal.svg": 3459,
	"./alert-circle.svg": 6477,
	"./arrow-left.svg": 6145,
	"./assignment-icon.svg": 6081,
	"./box.svg": 7789,
	"./chartering-icon.svg": 7617,
	"./check-icon.svg": 424,
	"./check.svg": 4414,
	"./chevron-right.svg": 4462,
	"./close.svg": 8298,
	"./faq-icon.svg": 9288,
	"./fleet-icon.svg": 1716,
	"./gavel.svg": 5383,
	"./globe-icon.svg": 5729,
	"./globe.svg": 5693,
	"./log-out-icon.svg": 1103,
	"./marketplace-icon.svg": 771,
	"./menu.svg": 3231,
	"./notification-icon.svg": 7759,
	"./orcas-logo-text.svg": 356,
	"./orcas-logo.svg": 4748,
	"./orders-icon.svg": 9373,
	"./payments-overview-icon.svg": 681,
	"./planner-icon.svg": 8892,
	"./sennfuel-icon.svg": 4068,
	"./star.svg": 6822,
	"./tenders-icon.svg": 4291,
	"./users-icon.svg": 2024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;